export const locale = {
  lang: 'vn',
  data: {
    HOME: {

    }
  },
};
